"use client";

import { motion } from "framer-motion";
import { fadeUp, viewportOnce } from "@/lib/motion";
import type { ReactNode } from "react";

interface SectionRevealProps {
  children: ReactNode;
  className?: string;
  id?: string;
  narrow?: boolean;
}

export function SectionReveal({
  children,
  className = "",
  id,
  narrow
}: SectionRevealProps) {
  return (
    <motion.section
      id={id}
      className={`py-12 lg:py-20 px-6 ${className}`}
      initial="hidden"
      whileInView="visible"
      viewport={viewportOnce}
      variants={fadeUp}
    >
      <div className={`mx-auto ${narrow ? "max-w-3xl" : "max-w-7xl"}`}>
        {children}
      </div>
    </motion.section>
  );
}
